import { contains, pluck } from "ramda";
import { findStoreByStoreKey } from "helpers/brand";
import type { IBrandGroup } from "helpers/transforms/entities";
import { SubscriptionLevel } from "interfaces/app";

function getSubscriptionLevel(
  brandGroup: IBrandGroup | undefined,
  vendorLevel: string,
  vendorLocation: string
): SubscriptionLevel | undefined {
  if (!brandGroup) {
    return undefined;
  }

  if (vendorLevel === "b") {
    return getSubscriptionLevelForBrandGroup(brandGroup);
  } else {
    const currentStore = findStoreByStoreKey(vendorLocation, [brandGroup]);
    return currentStore && currentStore.subscriptionLevel;
  }
}

function getSubscriptionLevelForBrandGroup(
  brandGroup: IBrandGroup
): SubscriptionLevel {
  const subscriptionLevels = pluck("subscriptionLevel", brandGroup.stores);
  if (contains(SubscriptionLevel.ENTERPRISE, subscriptionLevels)) {
    return SubscriptionLevel.ENTERPRISE;
  } else if (contains(SubscriptionLevel.PRO, subscriptionLevels)) {
    return SubscriptionLevel.PRO;
  } else {
    return SubscriptionLevel.CORE;
  }
}

export { getSubscriptionLevel, getSubscriptionLevelForBrandGroup };
